module.exports = __webpack_public_path__ + "img/2.9723fc0d.jpg";